// Mounts the platform-provided nomenclature-type create route at
// /admin/nomenclature/new. Default mount — platform field set
// (code/name/category) + submit pipeline (POST /api/nomenclature-types →
// navigate to /admin/nomenclature/$typeCode).

import { nomenclatureTypeCreateRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/nomenclature/new')({
  ...nomenclatureTypeCreateRoute,
  staticData: {
    breadcrumb: 'New type',
  },
})
